import { useEffect, useRef } from "react";

// Module-scoped flag survives across component re-renders within the same JS runtime.
// It resets only on a true cold start.
let hasPlacementFilterColdStarted = false;

/**
 * Hook to detect and execute a callback on app cold start (first launch).
 *
 * @param onColdStart - Callback to execute on cold start
 * @param enabled - Whether the hook should be active
 */
export function usePlacementFilterColdStart(onColdStart: () => void, enabled: boolean) {
  const ranThisSessionRef = useRef(false);
  const callbackRef = useRef(onColdStart);

  // Keep callback ref up to date
  callbackRef.current = onColdStart;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!hasPlacementFilterColdStarted) {
      hasPlacementFilterColdStarted = true;
      ranThisSessionRef.current = true;
      callbackRef.current();
    }
  }, [enabled]);
}
